import React, { useEffect, useState, useMemo, useRef } from "react";
import { Popover, Dialog, Button, Grid } from "@material-ui/core";
import OrgAndGroupList from "./OrgAndGroupList";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { makeStyles } from "@material-ui/core/styles";
import GroupLogo from "../../assets/images/groups.png";
import UserLogo from "../../assets/images/user.png";
import OrgLogo from "../../assets/images/org.png";
import withMiddleware from "../../middleware";
import SpinnerLoader from "react-loader-spinner";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { getMappingsList, setCurrentOrg, getUser } from "./handler";
import { updateUser } from "../../actions/app";
import { useUtils } from "../../utils";
import { setMappingsList } from "../../actions";

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: "5px 15px",
    minWidth: 120,
  },
  paper: {
    boxShadow: "none",
    background: "transparent",
  },
  imgContainer: {
    width: 80,
    height: 80,
    background: theme.palette.primary.main,
    display: "flex",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
  },
  img: { height: 40, width: 40 },
  loader: { width: 100, textAlign: "center" },
  selectPaper: {
    top: "48px !important",
  },
}));

function OrgAndGroupSelect(props) {
  const { service } = props;
  const dispatch = useDispatch();
  const [selection, setSelection] = useState();
  const [switchingTo, setSwitchingTo] = useState();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const classes = useStyles();
  const { showToast } = useUtils();
  const { user, mappings, mappingNames } = useSelector((state) => ({
    user: state.app.user,
    mappings: state.auth?.mappings || [],
    mappingNames: state.auth?.mappingNames || {},
  }));
  const history = useHistory();
  const pathName = window?.location?.pathname;
  const isOrgMode = window?.location?.pathname?.startsWith("/org");

  useEffect(() => {
    if (user?.current_org_id) {
      setSelection(isOrgMode ? user?.current_org_id : `${user?.current_org_id}_${user?.current_group_id}`);
    }
  }, [user?.current_org_id, user?.current_group_id, isOrgMode]);

  useEffect(() => {
    if (!mappings?.length) {
      (async () => {
        try {
          const list = await getMappingsList(service);
          dispatch(setMappingsList(list));
        } catch (error) {
          showToast("error", error?.message);
        }
      })();
    }
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleChange = async (org_id, group_id, user_type) => {
    try {
      const newSelection = user_type == "org" ? org_id : `${org_id}_${group_id}`;
      handleClose();
      if (newSelection != selection) {
        setSelection(newSelection);
        setSwitchingTo(user_type);
        await setCurrentOrg(service, { currentOrgId: String(org_id), currentGroupId: String(group_id), currentUserType: user_type });
        // window.location.replace(`/${user_type}`);
        // const user = await getUser(service);
        history.push(`/${user_type}`);
        setTimeout(() => {
          dispatch(updateUser({ ...user, current_org_id: org_id, current_group_id: group_id, user_type }));
        }, 1000);
      }
    } catch (error) {
      showToast("error", error?.message);
    } finally {
      setSwitchingTo(undefined);
    }
  };

  const name = mappingNames?.[selection];

  return mappings?.length ? (
    <div>
      <Button aria-describedby={id} size="small" variant="outlined" endIcon={<ArrowDropDownIcon />} color="primary" onClick={handleClick}>
        {name ? name : "Select Org or Group"}
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <OrgAndGroupList handleChange={handleChange} items={mappings} />
      </Popover>
      <Dialog
        open={!!switchingTo}
        classes={{
          paper: classes.paper,
        }}
      >
        <Grid container style={{ padding: 24 }}>
          <Grid className={classes.imgContainer}>
            <img src={isOrgMode ? OrgLogo : pathName?.startsWith("/group") ? GroupLogo : UserLogo} className={classes.img} />
          </Grid>
          <Grid className={classes.loader}>
            <SpinnerLoader type="ThreeDots" color="#fff" height={80} width={60} />
          </Grid>
          <Grid className={classes.imgContainer}>
            <img src={switchingTo == "org" ? OrgLogo : switchingTo == "group" ? GroupLogo : UserLogo} className={classes.img} />
          </Grid>
        </Grid>
      </Dialog>
    </div>
  ) : null;
}

export default withMiddleware(OrgAndGroupSelect);
